import { render, staticRenderFns } from "./GearInchInsights.vue?vue&type=template&id=6dd9bf30&scoped=true&"
import script from "./GearInchInsights.vue?vue&type=script&lang=js&"
export * from "./GearInchInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9bf30",
  null
  
)

export default component.exports